import { EContentPanelRoute } from 'lingo2-models';

export interface IFooterMenuItem {
  id: string;
  label?: string;
  icon?: string;
  route?: string;
}

export const menuItems: IFooterMenuItem[] = [
  {
    id: 'create-widget',
    icon: 'plus-green',
    route: null,
  },
  {
    id: 'my-classes',
    icon: 'my-classes',
    route: '/' + EContentPanelRoute['my-classes/dashboard'],
  },
  {
    id: 'calendar',
    icon: 'schedule',
    route: '/schedule/calendar',
  },
  {
    id: 'my-library',
    icon: 'my-library',
    route: '/' + EContentPanelRoute['my-library/lessons'],
  },
  {
    id: 'my-vocabulary',
    icon: 'my-vocabulary',
    route: '/my-vocabulary/main',
  },
  {
    id: 'favorites',
    icon: 'favorites',
    route: '/' + EContentPanelRoute['favorites/lessons'],
  },
];

export const menuItemsMe: IFooterMenuItem[] = [
  {
    id: 'my-classes',
    label: 'menu.left-sidebar.my-classes',
    icon: 'my-classes',
    route: EContentPanelRoute['my-classes/dashboard'],
  },
  {
    id: 'my-library',
    label: 'menu.left-sidebar.my-library',
    icon: 'my-library',
    route: EContentPanelRoute['my-library/lessons'],
  },
  {
    id: 'class',
    label: 'review.class',
    icon: 'plus-circle-2',
    route: null,
  },
  {
    id: 'my-vocabulary',
    label: 'menu.left-sidebar.my-vocabulary',
    icon: 'my-vocabulary',
    route: '/my-vocabulary/main' as EContentPanelRoute,
  },
  {
    id: 'calendar',
    label: 'menu.left-sidebar.schedule',
    icon: 'sidebar-schedule',
    route: '/schedule/calendar' as EContentPanelRoute,
  },
];
